import React from 'react';
import { Box } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { apiUpdateUser } from 'API/lotteryApi';
import { useAppDispatch, useAppSelector } from 'store/store';
import { currentUser } from 'store/actions/authActions';
import { addAlert } from 'store/reducers/alertReducer';
import { CustomTextField } from 'components/FormFields/CustomTextField/CustomTextField';
import RedButton from 'Styled/RedButton';
import TextButton from 'Styled/TextButton';
import { PageHeader } from 'components/Layout/PageHeader';

const validationSchema = Yup.object({
  email: Yup.string().email('Ungültige E-Mail').max(255, 'Höchstens 255 Zeichen').required('E-Mail ist erforderlich'),
});

/** Self-service e-mail change, matching the e-mail field of the Scala self-edit form. */
export const ChangeEmailPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Box>
      <PageHeader title="E-Mail ändern" />

      <Formik
        enableReinitialize
        initialValues={{ email: user?.email ?? '' }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting, setFieldError }) => {
          if (!user) {
            return;
          }
          try {
            await apiUpdateUser(user.id, { email: values.email });
            // Refresh the session user so the account menu shows the new address.
            await dispatch(currentUser());
            dispatch(addAlert({ message: 'E-Mail-Adresse erfolgreich geändert.', severity: 'success' }));
            navigate('/');
          } catch (err: unknown) {
            const message = (err as { message?: string })?.message;
            setFieldError('email', message ?? 'E-Mail-Adresse konnte nicht geändert werden.');
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
          <Form>
            <Box sx={{ maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomTextField
                name="email"
                label="E-Mail"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email ? errors.email : ''}
              />
              <Box sx={{ display: 'flex', gap: 2, marginTop: 2 }}>
                <RedButton type="submit" disabled={isSubmitting}>
                  Speichern
                </RedButton>
                <TextButton onClick={() => navigate(-1)}>Abbrechen</TextButton>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
